module.exports = function(app) {

	app.controller('pages.forgotPassword.step2', ["$state", "$scope", "$http", "coremetrics", "userService", function($state, $scope, $http, coremetrics, userService) {

        $scope.$parent.verificationSuccess = null;

        var phoneNumber = "1-877-298-3918";
        if ($scope.brandData.phoneNumbers && $scope.brandData.phoneNumbers.technical) {
            phoneNumber = $scope.brandData.phoneNumbers.technical;
        }

        $scope.footerMessage = {
            header: "",
            message: "",
            iconClass: "",
            show: false
        };

        $scope.cancelButton = function(){
            window.scrollTo(0,0);
            $scope.$parent.payload = "";
            $scope.$parent.goto(1);
        };

		$scope.sidebar = {
			heading: "Request Lost Information",
			description: "Some intro text here around what to expect in the process and all."
		};

        $scope.user = {
            securityQuestion:($scope.$parent.serviceData.payload) ? $scope.$parent.serviceData.payload.securityQuestion : $scope.cancelButton(),
            securityAnswer: ""
        };

        $scope.nextStep = function(screen){
            //validate
            if ($scope.user.securityAnswer != '') {

                $scope.footerMessage.show = false;
                $scope.disabledButton = true;

                //editPayload
                var payload = $scope.$parent.payload;
                payload.payload.reset = "";
                payload.payload.securityAnswer = $scope.user.securityAnswer;
                $scope.$parent.payload = payload;

                //call service
                $http({
                    url: "/rbsmbl/x-services/user/forgottenUsernamePassword",
                    method: "POST",
                    data: $scope.$parent.payload

                }).then(function(response) {
                    $scope.disabledButton = false;
                    window.scrollTo(0,0);
                    $scope.$parent.verificationSuccess = true;

                    // Finish step 2 conversion event
                    coremetrics.finishConversion('STEP 2 SECURITY QUESTION', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');

                    //go to next page
                    $scope.$parent.goto(3);

                }, function(error) {
                    //console.debug('error', error);
                    $scope.disabledButton = false;
                    $scope.$parent.chevron.step = 1;
                    $scope.$parent.verificationSuccess = false;

                    if (error.data.baseMessage.returnCodeDescription === 'GEN-SUSPEND') {
                        userService.showFooterMessage($scope.footerMessage, "WE HAVE TO SUSPEND YOUR ONLINE ACCESS",
                                                      "For security reasons we have to suspend your online access. For help, call " + phoneNumber, true);

                    } else if(error.data.baseMessage.returnCodeDescription === 'GEN-NOMATCHFORGOTTEN') {
                        userService.showFooterMessage($scope.footerMessage, "INCORRECT ANSWER", "Your entry does not match our records.", true);

                    } else {
                        userService.showFooterMessage($scope.footerMessage, "", "We are having trouble processing your request right now. Try again in a few minutes. " +
                            "If the problem continues, please call the number on the back of your member ID card.", true);
                    }

                });
            } else {
                return;
            }
        };

        $scope.checkQuestion = function() {
            var question = $scope.user.securityQuestion;
            if (question && question.charAt(question.length-1) != '?') {
                $scope.user.securityQuestion = question + '?';
            }
        };

        $scope.questionEndsWithMark = $scope.checkQuestion();

        // Start step 2 conversion event
        coremetrics.startConversion('STEP 2 SECURITY QUESTION', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');

	}]);
};